import * as React from "react";

import { FeatureToggleProvider } from "@kode-frontend/feature-toggle-react";

import { featureToggleConfig } from "./config";

type Props = {
  children: React.ReactNode;
};

export const FTProvider = ({ children }: Props) => {
  return (
    <FeatureToggleProvider config={featureToggleConfig}>
      <>{children}</>
    </FeatureToggleProvider>
  );
};
